import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppService } from '../services/app.service';
import { entityTypes } from 'src/app/shared/helpers/roles-permissions';

/**
 * Restricts a route to HOA staff, who sign in as INTERNAL.
 *
 * AuthGuard only checks permissions — its role check is commented out — so it
 * cannot express "INTERNAL only" on its own. Billing rate cards decide what every
 * client is charged, which is not something a client's own admin should reach.
 */
@Injectable({
  providedIn: 'root'
})
export class InternalEntityGuard implements CanActivate {

  constructor(private app: AppService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const account: any = this.app.getCurrentAccount();
    const entityType = account && account.entity && account.entity.entityType;

    if (entityType === entityTypes.INTERNAL) {
      return true;
    }

    this.router.navigate(['/dashboard']);
    return false;
  }
}
